var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"22","key":0}),React.createElement("path",{"d":"M18.9975 13L17 15.1641L23.4884 22.209L17 29.2539L18.9975 31.418L27.4976 22.209L18.9975 13Z","fill":"white","key":1})]);
}

ChevronRightInline.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
